'use client'

import Link from 'next/link'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { ARROW_ICON, cardData, commonEvents, redirectUrl, redirectUrlWithVehicleId } from '@constants/carComparison'
import Image from 'next/image'
import styles from './CarBrandInsuranceComparison.module.scss'

const CompareCard = ({ brandName, data }) => {
  const handleClick = () => {
    void trackEvent('tap_btn_CTA_widget', {
      ...{ commonEvents },
      product: brandName,
      journey: data.carName,
      cta_text: 'get quote',
    })
  }
  return (
    <Link
      className={styles.car}
      href={data?.vehicleId ? redirectUrlWithVehicleId(data?.vehicleId) : redirectUrl}
      onClick={handleClick}>
      <div className={styles.carHeader}>
        <div className={styles.carName}>
          <Image src={data?.carIcon?.data?.attributes?.url} alt="car-logo" height={64} width={64} loading="lazy" />
          <p>{data?.carName}</p>
        </div>
        <div className={styles.carQuoteCta}>
          <p>{cardData.cta}</p>
          <Image src={ARROW_ICON} alt="arrow" height={20} width={20} />
        </div>
      </div>
      <div className={styles.carPrices}>
        <div className={styles.carPrice}>
          <p className={styles.carPriceTitle}>{cardData.dealers}</p>
          <p>{data?.dealerPrice}</p>
        </div>
        <div className={styles.carPrice}>
          <p className={styles.carPriceTitle}>{cardData.acko}</p>
          <p>{data?.ackoPrice}</p>
        </div>
      </div>
      <div className={styles.carSavePrice}>
        <span>{cardData.savesLeft}</span>
        <span className={styles.carPrice}>{data?.savedPrice}</span>
        <span>{cardData.savesRight}</span>
      </div>
    </Link>
  )
}

export default CompareCard
